<template>
    <nav>
        <ul class="flex" :class="justify">
            <li v-for="item in items">
                <button
                    @click="invokeTabMenu(item)"
                    :class="{ '!border-green-600 text-black': selectedItem === item }"
                    class="mr-8 border-b-2 border-transparent pb-1 font-monument-extended text-sm text-[#666666] duration-300 lg:text-xl">
                    {{ item }}
                </button>
            </li>
        </ul>
    </nav>
</template>

<script lang="ts" setup>
    const props = defineProps({
        items: Array,
        justify: {
            type: String,
            default: 'justify-center',
            required: false,
        },
    });

    const selectedItem = ref('');
    const emit = defineEmits(['value']);

    function invokeTabMenu(item: any) {
        selectedItem.value = item;
        emit('value', selectedItem.value);
    }
    invokeTabMenu(props.items[0]);
</script>
